import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../core/bootstrap/models/site-config";
import {DeviceStore} from "../../../core/app/device.store";
import {RelatedEntitiesFactory} from "./related-entities-factory";
import {RelatedEntitiesApi} from "./related-entities.api";
import {SearchRepository} from "../../search/services/search-repository";

export class RelatedEntitiesRepository extends SearchRepository {
  static injectables = [DomUtils, LoggerUtils, SiteConfig, DeviceStore, RelatedEntitiesApi, RelatedEntitiesFactory];
}
